/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     PasswordManager
//   Details:    Password Manager store
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 108946 27/07/20 JC  M01  Pass current password when changing existing
// 109897 18/09/20 JC  M02  Added isForgottenPassword
//-------------------------------------------------------
*/

import { history } from '../history';
import { fetchActions } from "../FetchWrapper";
import { userActions } from './Authentication';

export const changePasswordRequiredType = "CHANGE_PASSWORD_REQUIRED";
export const changePasswordRequestType = "CHANGE_PASSWORD_REQUEST";
export const changePasswordSuccessType = "CHANGE_PASSWORD_SUCCESS";
export const changePasswordFailureType = "CHANGE_PASSWORD_FAILURE";

const initialState = {
    changingPassword: false,
    isPasswordChangeRequired: false,
    isForgottenPassword: false
}; //M02

export const passwordActions = {
	changeRequired,
	change
};

function changeRequired(isForgottenPassword) {
	return (dispatch) => {
        dispatch(_request(isForgottenPassword)); //M02
	};

    function _request(isForgottenPassword) { return { type: changePasswordRequiredType, isForgottenPassword: isForgottenPassword }; } //M02
}

function change(currentPassword, newPassword, repeatPassword) { //M01
	return (dispatch, getState) => {
		if (!getState().clientConfiguration.config.endpoint)
			return;

		dispatch(_request());

		const url = getState().clientConfiguration.config.endpoint + "/employees/changepassword";
		const ticket = getState().authentication.user.ticket;
        const data = { currentPassword: currentPassword, newPassword: newPassword, repeatPassword: repeatPassword }; //M01

		fetchActions.post(url, ticket, data)
			.then(
            () => {
                    //M01 always show password changed
					//if (!getState().passwordManager.isPasswordChangeRequired) {
					history.push('/passwordchanged');
					dispatch(userActions.loginCompleted());
					//}
					dispatch(_success());
				},
				error => {
					if (error.sessionExpired) {
						dispatch(userActions.sessionExpired());
					}
					else {
						var message = `Could not change password: ${error.message}`;
						dispatch(_failure(message));
					}
				}
			);
	};

	function _request() { return { type: changePasswordRequestType }; }
	function _success() { return { type: changePasswordSuccessType }; }
	function _failure(error) { return { type: changePasswordFailureType, error }; }
}

export const reducer = (state, action) => {
	state = state || initialState;

	if (action.type === changePasswordRequiredType) {
        return {
            ...state, success: undefined, isPasswordChangeRequired: true, isForgottenPassword: action.isForgottenPassword,
            error: "You must change your password to continue" //M02
        };
	}

	if (action.type === changePasswordRequestType) {
		return { ...state, success: undefined };
	}

	if (action.type === changePasswordSuccessType) {
        return { ...state, success: "Your password has been changed.", isPasswordChangeRequired: false, isForgottenPassword:false, error: undefined };//M02
	}

	if (action.type === changePasswordFailureType) {
		return { ...state, error: action.error };
	}

	return state;
};